import { render, staticRenderFns } from "./AccountEmployeeDuplicate.vue?vue&type=template&id=7645d42c&scoped=true"
import script from "./AccountEmployeeDuplicate.vue?vue&type=script&lang=js"
export * from "./AccountEmployeeDuplicate.vue?vue&type=script&lang=js"
import style0 from "./AccountEmployeeDuplicate.vue?vue&type=style&index=0&id=7645d42c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7645d42c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7645d42c')) {
      api.createRecord('7645d42c', component.options)
    } else {
      api.reload('7645d42c', component.options)
    }
    module.hot.accept("./AccountEmployeeDuplicate.vue?vue&type=template&id=7645d42c&scoped=true", function () {
      api.rerender('7645d42c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/AccountEmployeeDuplicate.vue"
export default component.exports